import { ShieldCheck } from 'lucide-react';
import { formatEnabledSince } from '../../utils/twoFactor';

interface TwoFactorActiveNoticeProps {
  /** ISO-Zeitstempel der Aktivierung (laut Backend). */
  enabledAt?: string | undefined;
}

/** Statusanzeige für aktive 2FA; weist darauf hin, dass nur ein Super Admin sie zurücksetzen kann. */
export function TwoFactorActiveNotice({ enabledAt }: TwoFactorActiveNoticeProps) {
  const since = formatEnabledSince(enabledAt);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-green-700">
        <ShieldCheck className="w-5 h-5" />
        <span className="font-medium">{since ? `Aktiv seit ${since}` : 'Aktiv'}</span>
      </div>
      <p className="text-sm text-gray-600">
        Du kannst die Zwei-Faktor-Authentifizierung nicht selbst deaktivieren. Bei Verlust deines Geräts kann ein
        Super Admin sie für dich zurücksetzen.
      </p>
    </div>
  );
}
